<div ktOffcanvas [options]="offcanvasOptions" id="failure_mode_info_panel" class="kt-quick-panel file-brower-panel"
    [ngStyle]="{ bottom: 'unset'}" #ktOffCanvasRef="ktOffcanvas">
    <div class="kt-portlet">
        <div class="kt-portlet__head kt-portlet__head__custom">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">File Browser</h3>
            </div>
            <div class="kt-portlet__head-toolbar" #refTools [hidden]="false">
                <div class="assets-tool-box">
                    <div *ngIf="showDownloadHierarchyButton">
                        <button type="button" class="btn btn-icon btn-prmy"
                            [ngClass]="{'disable-hover': isLoadingFolderStructure}" (click)="downloadFolderStructure()"
                            matTooltip="Download Folder Structure"
                            [disabled]="isLoadingFolderStructure"><mat-icon>download</mat-icon></button>
                    </div>&nbsp;&nbsp;
                    <div>
                        <button type="button" class="btn btn-icon btn-prmy"
                            [ngClass]="{'disable-hover': disableAction}" (click)="fileInput.click()"
                            matTooltip="Select File"
                            [disabled]="disableAction"><mat-icon>file_upload</mat-icon></button>
                        <input #fileInput type="file" style="display: none" (change)="handleFileUpload($event)" [accept]="acceptedFileTypes"
                            onclick="this.value=null;">
                    </div>&nbsp;&nbsp;
                    <div>
                        <button type="button" class="btn btn-icon btn-prmy"
                            [ngClass]="{'disable-hover': disableAction}" matTooltip="Create Folder"
                            (click)="createNewFolder()"
                            [disabled]="disableAction"><mat-icon>create_new_folder</mat-icon></button>
                    </div>&nbsp;&nbsp;
                    <button class="btn btn-icon btn-prmy" matTooltip="Close" (click)="close()">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="kt-portlet__body file-browser-body-container">
            <kt-file-browser-content (isCurrentSelectionOpened)="isCurrentSelectionOpened($event)"></kt-file-browser-content>
        </div>
        <div style="flex-grow: 1;">
            <kt-chart-loader *ngIf="isLoading"></kt-chart-loader>
        </div>
    </div>
</div>
<div class="file-browser-outer-button-container">
    <button class="file-brower-button" (click)="toggleFileBrowser()"><mat-icon>backup</mat-icon></button>
</div>
